import { render, staticRenderFns } from "./ModattaSideModalNewOfferAudienceByLocation.vue?vue&type=template&id=cc78cab2"
import script from "./ModattaSideModalNewOfferAudienceByLocation.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalNewOfferAudienceByLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports